<template>
  <div class="l-content container-fluid" :class="[ backgroundGray, noOverflow ]" v-if="$route.name !== 'ClaimsEdit' && $route.name !== 'ContractCreate' && $route.name !== 'ContractEdit' && $route.name !== 'CompanyRatings'">
    <router-view />
  </div>
  <div class="l-content" v-else>
    <router-view />
  </div>
</template>

<script>
export default {
  computed: {
    backgroundGray() {
      if (
        this.$route.path === '/' ||
        this.$route.path === '/carriers' ||
        this.$route.path === '/claims' ||
        this.$route.path === '/companies' ||
        this.$route.path === '/contracts' ||
        this.$route.path === '/customers' ||
        this.$route.path === '/jobs' ||
        this.$route.path === '/leads' ||
        this.$route.path === '/movers' ||
        this.$route.path === '/reports/discounts' ||
        this.$route.path === '/reports/mover-totals' ||
        this.$route.path === '/reports/ratings' ||
        this.$route.path === '/reports/sales' ||
        this.$route.path === '/reports/totals' ||
        this.$route.path === '/settings/acknowledgement-templates' ||
        this.$route.path === '/settings/claim-templates' ||
        this.$route.path === '/settings/claim-types' ||
        this.$route.path === '/settings/domains' ||
        this.$route.path === '/settings/follow-up-templates' ||
        this.$route.path === '/settings/messages' ||
        this.$route.path === '/settings/mover-messages' ||
        this.$route.path === '/settings/payment-gateways' ||
        this.$route.path === '/settings/phone-numbers' ||
        this.$route.path === '/settings/settlement-templates' ||
        this.$route.path === '/settings/smtp-servers' ||
        this.$route.path === '/settings/filters' ||
        this.$route.path === '/settings/tags' ||
        this.$route.path === '/settings/user-roles' ||
        this.$route.path === '/transactions' ||
        this.$route.path === '/trucks' ||
        this.$route.path === '/users'
      ) {
        return 'new-bg';
      }
      return '';
    },
    noOverflow() {
      if (this.$route.name === 'Jobs') {
        return 'no-overflow-x';
      }
      return '';
    },
  },
};
</script>
<style>
.new-bg {
  background: #f1f4f7;
}
.no-overflow-x {
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/LayoutContent.vue